export const blockIconsPlacesBathtub = (
	<span className='material-symbols-outlined'>bathtub</span>
);
